import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-select-payment',
  templateUrl: './select-payment.component.html',
  styleUrls: ['./select-payment.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SelectPaymentComponent implements OnInit {
  transaction_id: string;
  payment_channels: any[];
  selected_payment: any;
  popup_message_payment: any | null

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
  ) {
    this.transaction_id = route.snapshot.params.id;
    this.payment_channels = route.snapshot.data.payment_channels
    this.popup_message_payment = route.snapshot.data.popup_message_payment

    window.scrollTo(0, 0);
  }

  ngOnInit() {
  }

  selectPaymentConfirmation(payment, template) {
    this.selected_payment = payment;
    this.modalService.open(template, {ariaLabelledBy: 'modal-basic-title', centered: true, windowClass: "payment-confirmation-dialog"}).result.then((result) => {
      this.router.navigate([`/transaction/${this.transaction_id}/payment-proof`]);
      // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

}
